module.exports = __webpack_public_path__ + "img/1526899105.499817aa.jpg";